import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { toast } from "react-hot-toast";
import {
  useSingleScoreBasedRecommendationQuery,
  useUpdateScoreBasedRecommendationMutation,
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import {
  FormInput,
  FormSelect,
  FormTextArea,
} from "../../../../Components/Forms/InputTemplate";

const EditScoreBasedModal = ({
  setIsOpen,
  isOpen,
  onValidate = () => { },
  id,
}) => {
  const { data } = useSingleScoreBasedRecommendationQuery(id);
  const [onUpdate, { isLoading }] = useUpdateScoreBasedRecommendationMutation();
  const formMethods = useForm({
    mode: "all",
    defaultValues: {
      recommendationTitle: "",
      fromScore: 0,
      toScore: 0,
      recommendationDescription: "",
    },
  });

  const {
    handleSubmit,
    formState: { isValid },
    reset,
  } = formMethods;
  useEffect(() => {
    console.log(`parseInt(data?.employeeType)`, data)
    if (data?.responseObject) {
      reset({
        recommendationTitle: data.responseObject.recommendationTitle || "",
        fromScore: data.responseObject.fromScore || 1,
        employeeType: parseInt(data?.responseObject?.employeeType),
        toScore: data.responseObject.toScore,
        recommendationDescription:
          data.responseObject.recommendationDescription,
      });
    }
  }, [data, reset]);

  const submit = async (data) => {
    const payload = {
      id,
      employeeType: parseInt(data?.employeeType),
      recommendationTitle: data.recommendationTitle,
      fromScore: parseInt(data.fromScore),
      toScore: parseInt(data.toScore),
      recommendationDescription: data.recommendationDescription,
    };
    if (!id) {
      toast.error("Rating Scale ID is required");
      return;
    }
    try {
      const response = await onUpdate(payload).unwrap();
      if (response.successful) {
        toast.success(response.statusMessage);
        setIsOpen(false);
        onValidate();
      }
    } catch (err) {
      toast.error(err.data.statusMessage ?? "Error Score Based Recommendation");
    }
  };

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Edit </h4>
          <h1 className="text-[28px] font-[800]">SCore Based Recommendation</h1>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <form onSubmit={handleSubmit(submit)} className="space-y-6">
              <FormSelect
                title={"Employee Type"}
                camelCase={"employeeType"}
                // defaultValue={''}
                array={[{
                  label: "New", value: 1
                }, { label: "Existing", value: 2 }]?.map(dat => <option value={dat?.value} key={dat.value}>{dat?.label}</option>)}
              />
              <FormInput
                title={"Recommendation Title"}
                camelCase={"recommendationTitle"}
                placeholder={"select"}
              />
              <FormInput
                title={"Minimum"}
                camelCase={"fromScore"}
                placeholder={"select"}
              />
              <FormInput
                title={"Maximum"}
                camelCase={"toScore"}
                placeholder={"select"}
              />
              <FormTextArea
                className="h-[200px]"
                title={"Recommendation Description"}
                camelCase={"recommendationDescription"}
              />
              <div
                style={{ marginTop: "1rem" }}
                className={DashboardStyle.button_cage}
              >
                <ActionButtons
                  isLoading={isLoading}
                  disabled={!isValid}
                  width={"auto"}
                  type={"submit"}
                  // onClick={onValidate}
                  className={DashboardStyle?.button_cage_weight}
                  bg="var(--primary-color)"
                >
                  Update
                </ActionButtons>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default EditScoreBasedModal;
